import React, { useState, useRef, useEffect, useMemo, useCallback } from 'react';
import { getMetaDataforcustomReport, getPredefinedReportsforcustomReport, getPredefinedReportcolumnforcustomReportByReportId, getPreviewReportByParams, DownloadPreviewReportByParams, getDistinctValuesForTablByTablecolumn } from './PerformanceTracker/actioncreator';
import Loader from '../../../presentationals/Loader/Loader.component'
import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';
import moment from 'moment';
import RemoveIcon from "@mui/icons-material/Remove";
import Accordion from '@mui/material/Accordion';
import AccordionActions from '@mui/material/AccordionActions';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import Button from '@mui/material/Button';
import Chip from '@mui/material/Chip';
import { APIS } from '../../../../utils/api-factory';

const itemsPerPage = 10;
const accordionItemsPerPage = 7;
const CustomReportGenerator = () => {

    const tableRef = useRef(null);
    const dropdownRef = useRef(null);
    const dropdown2Ref = useRef(null);
    const [reportType, setReportType] = useState("dynamic")
    const [selectedReport, setSelectedReport] = useState("")
    const [showColumnDropdown, setShowColumnDropdown] = useState(false)
    const [showColumnDropdownFilter, setShowColumnDropdownFilter] = useState(false)
    const [columns, setColumns] = useState([]);
    const [filters, setFilters] = useState([]);
    const [loader, setLoader] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);

    const [metadata, setMetadata] = useState([]);
    const [searchTerm, setSearchTerm] = useState("")
    const [predefined, setPredefined] = useState([]);
    const [PreviewTableData, setPreviewTableData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [showPreview, setShowPreview] = useState(false);

    const [previewPaginatedData, setpreviewPaginatedData] = useState([]);
    const [totalItems, settotalItems] = useState(1);

    const [isOpenSidebar, setIsOpenSidebar] = useState(false);

    const [columnBlock, setcolumnBlock] = useState([])
    const [expanded, setExpanded] = useState(null);
    const [selectedColumns, setSelectedColumns] = useState({});
    const [accordionCurrentPage, setAccordionCurrentPage] = useState(1);
    const [selectedTableShow, setselectedTableShow] = useState({})
    const [nbfcList, setnbfcList] = useState([])
    const [selectednbfc, setSelectednbfc] = useState("")
    const [dateParams, setDateParams] = useState({
        mongo_start_date: "",
        mongo_end_date: ""
    })


    const paginatedAccordionData = useMemo(() => {
        if (columnBlock?.length > 0) {
            const startIndex = (accordionCurrentPage - 1) * accordionItemsPerPage;
            const endIndex = startIndex + accordionItemsPerPage;
            return columnBlock.slice(startIndex, endIndex);
        }
        return [];
    }, [columnBlock, accordionCurrentPage]);

    const handleAccordionPageChange = (page) => {
        const totalPages = Math.ceil(columnBlock.length / accordionItemsPerPage);
        if (page >= 1 && page <= totalPages) {
            setAccordionCurrentPage(page);
            setExpanded(null);
        }
    };

    const getNbfcList = () => {
        fetch(APIS.GET_LIST_OF_NBFC)
            .then(res => res.json())
            .then(res => {
                setnbfcList(res)
            })
    }

    useEffect(() => {
        handleSelectBox("dynamic", "reportType")
        getNbfcList()

        function handleClickOutside(event) {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setShowColumnDropdown(false);
            }
            if (dropdown2Ref.current && !dropdown2Ref.current.contains(event.target)) {
                setShowColumnDropdownFilter(false);
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);





    const handleSelectBox = (value, type) => {
        if (type == "reportType") {
            setDateParams({
                mongo_start_date: "",
                mongo_end_date: ""
            })
            setSelectednbfc("")
            setReportType(value)
            setSelectedReport("")
            setShowColumnDropdown(false)
            setSearchTerm("")
            setColumns([])
            setFilters([])
            setSelectedColumns([])
            setselectedTableShow([])
            setShowPreview(false)
            if (value == "dynamic") {
                getMetaDataforcustomReportFn()
            } else {
                getPredefinedReportsforcustomReportFn()
            }
        }
    }

    const getMetaDataforcustomReportFn = () => {
        setLoader(true)
        getMetaDataforcustomReport(callback => {
            setLoader(false)
            setMetadata(callback)
            if (callback?.length > 0) {
                const transformedData = transformMetadata(callback)
                setcolumnBlock(transformedData)
            }
        })
    }

    const transformMetadata = (rawData) => {

        const groupedByTable = rawData?.reduce((acc, item) => {
            const tableName = item?.table;


            if (!acc[tableName]) {
                acc[tableName] = [];
            }


            acc[tableName].push({
                column: item.column,
                label: item.label,
                data_type: item.data_type
            });

            return acc;
        }, {});


        const result = Object.keys(groupedByTable).map((tableName, index) => ({
            id: index + 1,
            tableName: tableName,
            columns: groupedByTable[tableName]
        }));

        return result;
    }
    const getPredefinedReportsforcustomReportFn = () => {
        setLoader(true)
        getPredefinedReportsforcustomReport(callback => {
            setLoader(false)
            setMetadata([]);
            setPredefined(callback)
        })
    }
    const getPredefinedReportcolumnforcustomReportByReportIdFn = (id) => {
        setLoader(true)
        getPredefinedReportcolumnforcustomReportByReportId(id, callback => {
            setLoader(false)
            setMetadata(callback)

        })
    }

    function getQueryParams(download = false) {
        const params = new URLSearchParams();
        new Set([
            ...columns.map(c => c.split('.')[0]),
            ...filters.map(f => f.column.split('.')[0]),
        ]).forEach(t => params.append('tables', t));

        columns.forEach(c => params.append('columns', c));
        const filterStr = filters
            .filter(f => f.value)
            .map((f, i) => {
                let val = f.value;
                if (f.operator === 'LIKE') {
                    // default to contains
                    val = `%${val}%`;
                }
                const expr = `${f.column} ${f.operator} '${val}'`;
                return i ? `${f.logic} ${expr}` : expr;
            })
            .join(' ');

        if (filterStr) params.append('filter', filterStr);
        if (reportType === 'predefined' && selectedReport)
            if (selectedReport == 15 || selectedReport == 41) {
                params.append('nbfc_id', selectednbfc);
            }
        params.append('report_id', selectedReport);
        if (download) params.append('_download', 'true');
        return params;
    }


    const preview = () => {
        setLoading(true);


        const params = getQueryParams();
        getPreviewReportByParams(params, dateParams, callback => {
            setPreviewTableData(callback)
            settotalItems(callback?.length)
            handlePaginationData(1, callback)
            setCurrentPage(1)
            setShowPreview(true);
            setLoading(false);
            setExpanded(null)
            scrollToBottom()
        })

    };

    const download = () => {
        setLoader(true)
        const filename =
            reportType === "predefined"
                ? predefined?.length > 0
                    ? predefined.find(el => el?.report_id === selectedReport)?.report_name || "report"
                    : "report"
                : "report";
        const params = getQueryParams(true);
        DownloadPreviewReportByParams(params, dateParams, filename, callback => {
            setLoader(false)
            setSelectedReport("")
            setShowColumnDropdown(false)
            setSearchTerm("")
            setColumns([])
            setFilters([])
            setSelectedColumns({})
            setSelectednbfc("")
        })
    };


    const filteredMetadata = useMemo(() => {
        let arr = []

        if (reportType === "dynamic") {

            if (metadata && metadata.length > 0) {
                arr = metadata.filter(col => {
                    const searchValue = `${col.label} (${col.table}.${col.column})`.toLowerCase();
                    return searchValue.includes(searchTerm.toLowerCase());
                })
            }
        } else {

            if (selectedReport && metadata && metadata.length > 0) {

                arr = metadata.filter(col => {
                    const searchValue = `${col?.display_label} (${col.table_from}.${col.column_name})`.toLowerCase();
                    return searchValue.includes(searchTerm.toLowerCase());
                })
            } else if (!selectedReport && predefined && predefined.length > 0) {

                arr = []
            }
        }

        return arr;
    }, [searchTerm, metadata, predefined, reportType, selectedReport]);


    const handlePageChange = (page) => {
        if (page >= 1 && page <= totalItems) {
            setCurrentPage(page);
            handlePaginationData(page, PreviewTableData)
        }

    };


    const handlePaginationData = (currentPage, data) => {
        const updatedData = data?.length > 0 ? data?.slice(
            (currentPage - 1) * itemsPerPage,
            currentPage * itemsPerPage
        ) : [];

        setpreviewPaginatedData(updatedData)
    }


    const addFilter = useCallback(() => {
        setFilters([...filters, { column: '', operator: '=', value: '', logic: 'AND' }]);
        setIsOpenSidebar(true);
    }, [filters]);

    const removeFilter = useCallback((index) => {
        setFilters(filters.filter((_, i) => i !== index));
        if (filters.length === 1) setIsOpenSidebar(false);
    }, [filters]);


    const scrollToBottom = () => {
        setTimeout(() => {
            tableRef.current.scrollIntoView({ behavior: 'smooth' });
        }, 400)
    };

    const handleCheckboxChange = (companyId, columnName) => {
        console.log(companyId, "columnName", columnName)
        const value = `${companyId}.${columnName}`
        setSelectedColumns((prev) => {
            const current = prev[companyId] || [];
            const isChecked = current?.includes(columnName)
            let updatedSelection;
            if (isChecked) {
                updatedSelection = current?.filter((col) => col !== columnName)
                setColumns(columns.filter((c) => c !== value));
            } else {
                updatedSelection = [...current, columnName];
                setColumns([...columns, value]);
            }
            return { ...prev, [companyId]: updatedSelection };
        });
    };

    const handleDateFilter = (e, type) => {
        setDateParams((prev) => ({
            ...prev,
            [type]: e.target.value
        }))
    }


    const isTableFullySelected = (tableName, columns) => {
        if (Object.keys(selectedTableShow)?.includes(tableName)) {
            return true;
        }
        return false;
    };


    const handleTableCheckboxChange = (e, tableName, dataMain) => {
        e.stopPropagation();
        const isFullySelected = Object.keys(selectedColumns)?.includes(tableName);
        const isFullySelectedData = Object.keys(selectedTableShow)?.includes(tableName);

        // setSelectedColumns((prev) => {
        //     const newSelectedColumns = { ...prev };
        //     if (isFullySelected) {
        //         delete newSelectedColumns[tableName];
        //     } else {
        //         newSelectedColumns[tableName] = [];
        //     }
        //     return newSelectedColumns;
        // });

        setselectedTableShow((prev) => {
            const data = { ...prev }
            if (isFullySelectedData) {
                delete data[tableName]
            } else {
                data[tableName] = dataMain?.columns
            }
            console.log("dd", data)
            return data
        })

    };

    const totalCalculate = (type) => {
        let count = 0;
        if (type == "selectedColumn") {
            const arr = Object.values(selectedColumns)?.map((v, id) => {
                count += v?.length
            });
            return count;
        }
        if (type == "column") {
            const arr = Object.values(selectedTableShow)?.map((v, id) => {
                count += v?.length
            });
            return count;
        }
    }


    const handleallSelect = (e) => {
        const isChecked = e.target.checked;
        if (isChecked) {

            const newSelectedColumns = {};
            const newColumns = [];

            Object.entries(selectedTableShow).forEach(([tableName, tableColumns]) => {
                newSelectedColumns[tableName] = tableColumns.map(col => col.column);


                tableColumns.forEach(col => {
                    newColumns.push(`${tableName}.${col.column}`);
                });
            });

            setSelectedColumns(newSelectedColumns);
            setColumns(newColumns);
        } else {

            setSelectedColumns({});
            setColumns([]);
        }
    }

    const isAllSelected = () => {
        const totalAvailableColumns = totalCalculate("column");
        const totalSelectedColumns = totalCalculate("selectedColumn");

        return totalAvailableColumns > 0 && totalSelectedColumns === totalAvailableColumns;
    };

    return (
        <div className='customReportScss'>
            {loader ?
                <Loader />
                : ''}
            <div className="container-fluid">
                <div className='builder-Tabs'>
                    <div className="tab-header">
                        <div className='head-sub'>
                            <div className="icons-head">
                                <svg className="iconsclass" fill="currentColor" viewBox="0 0 24 24">
                                    <path d="M12 3L2 12h3v8h6v-6h2v6h6v-8h3L12 3zm5 15h-2v-6H9v6H7v-6.81l5-4.5 5 4.5V18z" />
                                </svg>
                            </div>
                            <h3 className="heading-text">Report Builder</h3>
                        </div>
                    </div>

                    <div className="tabs-main">
                        <div className="row">
                            <div className="col-sm-3 col-xs-12">
                                <div className='mainFilter'>
                                    <label
                                        className='custom-label'
                                    >
                                        Report Type
                                    </label>

                                    <select
                                        className='custom-Select-box-new'

                                        value={reportType}
                                        onChange={(e) => handleSelectBox(e.target.value, "reportType")}

                                    >
                                        <option value="dynamic">Dynamic Report</option>
                                        <option value="predefined">Predefined Report</option>
                                    </select>
                                </div>

                            </div>
                            {/* {
                                reportType === "predefined" ?

                                    <div className="col-sm-2 col-xs-12">
                                        <div className='mainFilter'>
                                            <label
                                                className='custom-label'
                                            >
                                                Predefined Report
                                            </label>

                                            <select
                                                className='custom-Select-box-new'

                                                value={selectedReport}
                                                onChange={(e) => {
                                                    setSelectedReport(e.target.value);
                                                    getPredefinedReportcolumnforcustomReportByReportIdFn(e.target.value)
                                                    setDateParams({
                                                        mongo_start_date: "",
                                                        mongo_end_date: ""
                                                    })
                                                    setSelectednbfc("")
                                                }}

                                            >
                                                <option value="">Select Report</option>
                                                {predefined?.length > 0 ? predefined?.map(r => (
                                                    <option key={r.report_id} value={r.report_id}>
                                                        {r.report_name}
                                                    </option>
                                                )) : ''}
                                            </select>
                                        </div>

                                    </div>

                                    : ''} */}
                            {
                                reportType === "predefined" ?
                                    <>
                                        <div className="col-sm-2 col-xs-12">
                                            <div className='mainFilter'>
                                                <label
                                                    className='custom-label'
                                                >
                                                    Start Date
                                                </label>
                                                <input
                                                    type="date"
                                                    className="custom-Select-box-new"
                                                    value={dateParams?.mongo_start_date}
                                                    onChange={(e) => handleDateFilter(e, "mongo_start_date")}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-sm-2 col-xs-12">
                                            <div className='mainFilter'>
                                                <label
                                                    className='custom-label'
                                                >
                                                    End Date
                                                </label>
                                                <input
                                                    type="date"
                                                    className="custom-Select-box-new"
                                                    value={dateParams?.mongo_end_date}
                                                    onChange={(e) => handleDateFilter(e, "mongo_end_date")}
                                                />
                                            </div>
                                        </div>
                                    </>
                                    : ''}
                            {
                                reportType === "predefined" && (selectedReport == 15 || selectedReport == 41) ?
                                    <>
                                        <div className="col-sm-2 col-xs-12">
                                            <div className='mainFilter'>
                                                <label
                                                    className='custom-label'
                                                >
                                                    NBFC
                                                </label>
                                                <select className="custom-Select-box-new" value={selectednbfc} onChange={(e) => setSelectednbfc(e.target.value)}>
                                                    <option value={""}>Select NBFC</option>
                                                    {
                                                        nbfcList && nbfcList?.length > 0 ? nbfcList?.map((v, id) => {
                                                            return (
                                                                <option value={v?.nbfcId}>{v?.name}</option>
                                                            )
                                                        })
                                                            : ''}
                                                </select>
                                            </div>
                                        </div>

                                    </>
                                    : ''}




                        </div>

                        <div className="row" style={{ marginTop: '20px' }}>
                            <div className="col-sm-3 col-xs-12" style={{ display: 'flex', gap: '15px' }}>
                                <button
                                    // style={{ marginTop: '25px' }}
                                    onClick={() => setIsOpenSidebar(true)}
                                    className="previewButton"
                                >

                                    <AddIcon />
                                    <span>Filter</span>

                                </button>
                                <button
                                    // style={{ marginTop: '25px' }}
                                    onClick={() => handleSelectBox(reportType, "reportType")}
                                    className="previewButton"
                                >
                                    <span>Clear Filter</span>

                                </button>
                            </div>
                            <div className="col-sm-2 col-xs-12">
                                <button
                                    onClick={preview}
                                    disabled={loading == true ? true : false}
                                    className="previewButton"
                                >
                                    {loading ? (
                                        <div className="spinner-custom"></div>
                                    ) : (
                                        <>
                                            <svg style={{ width: '20px', height: '20px' }} fill="currentColor" viewBox="0 0 24 24">
                                                <path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z" />
                                            </svg>
                                            <span>Preview Report</span>
                                        </>
                                    )}
                                </button>
                            </div>
                            {showPreview && (
                                <div className="col-sm-2 col-xs-12">
                                    <button
                                        onClick={() => download()}
                                        className="custom-download-btn"
                                    >
                                        <svg style={{ width: '20px', height: '20px' }} fill="currentColor" viewBox="0 0 24 24">
                                            <path d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z" />
                                        </svg>
                                        <span>Export Report</span>
                                    </button>
                                </div>
                            )}
                        </div>
                    </div>
                </div>

                {reportType === "dynamic" && (
                    <>
                        <div style={{ marginTop: '20px' }}>
                            <Accordion>
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel1-content"
                                    id="panel1-header"
                                    sx={{
                                        borderBottom: '1px solid #b5b5b5'
                                    }}
                                >
                                    <Typography component="span">Tables</Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: window.innerWidth > 1800 ? "13px" : "8px", padding: '10px' }}>
                                        {
                                            columnBlock?.length > 0 ? columnBlock?.map((v, id) => {
                                                return (
                                                    <Chip label={v?.tableName?.replace(/_/g, " ")?.toUpperCase()} variant="outlined"
                                                        onClick={(e) => handleTableCheckboxChange(e, v?.tableName, v)}

                                                        sx={{
                                                            fontSize: window.innerWidth > 1800 ? "14px" : '8px',
                                                            // border: isTableFullySelected(v?.tableName, v?.columns) ? "1px solid #9333ea" : '1px solid rgba(0,0,0,0.4)',
                                                            // backgroundImage: isTableFullySelected(v?.tableName, v?.columns) ? "linear-gradient(to right, #7c3aed, #9333ea)" : "#fff",
                                                            border: '1px solid rgba(0,0,0,0.4)',
                                                            background: isTableFullySelected(v?.tableName, v?.columns) ? "#000" : "#fff",
                                                            ".MuiChip-label": {
                                                                padding: window.innerWidth > 1800 ? "10px" : '',
                                                                color: isTableFullySelected(v?.tableName, v?.columns) ? "#fff" : "#000",
                                                            },
                                                            "&:hover": {
                                                                background: "#000 !important",
                                                                ".MuiChip-label": {
                                                                    color: "#fff !important",
                                                                }
                                                            }
                                                        }}
                                                    />
                                                )
                                            })
                                                : ''}
                                    </div>
                                    <hr style={{ borderTop: '1px solid #b5b5b5', margin: '10px 0 5px 0' }} />
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '0 7px' }}>
                                        {/* <h5>Total Columns : {totalCalculate("column") ?? 0}</h5>
                                        <h5>Columns Selected : {totalCalculate("selectedColumn") ?? 0}</h5> */}
                                        <input type='checkbox' style={{ margin: '0' }} checked={isAllSelected()} onChange={(e) => handleallSelect(e)} />
                                        <h5 style={{ flexShrink: '0' }}>Columns Selected : </h5>
                                        <div style={{ display: 'flex', gap: '5px', overflowX: 'auto', width: '90%', scrollbarWidth: "thin" }}>

                                            {
                                                selectedColumns && Object.entries(selectedColumns)?.map(([key, v], id) => {

                                                    return v?.length > 0 && v?.map((value, i) => {
                                                        return (
                                                            <Chip label={value?.replace(/_/g, " ")} variant="outlined"

                                                                onDelete={() => handleCheckboxChange(key, value)}
                                                                deleteIcon={<CloseIcon />}
                                                                sx={{
                                                                    fontSize: window.innerWidth > 1800 ? "14px" : '8px',
                                                                    border: '1px solid rgba(0,0,0,0.4)',
                                                                    background: "#000",
                                                                    ".MuiChip-label": {
                                                                        padding: window.innerWidth > 1800 ? "10px" : '',
                                                                        color: "#fff",
                                                                        fontSize: window.innerWidth > 1800 ? "14px" : '8px',
                                                                    },
                                                                    "& .MuiChip-deleteIcon": {
                                                                        color: "#fff",
                                                                        "&:hover": {
                                                                            color: "#000",
                                                                        }
                                                                    },
                                                                    "&:hover": {
                                                                        background: "#fff !important",
                                                                        ".MuiChip-label": {
                                                                            color: "#000 !important",
                                                                        }
                                                                    }
                                                                }}
                                                            />
                                                        )

                                                    })
                                                })
                                            }
                                        </div>
                                    </div>
                                    <hr style={{ borderTop: '1px solid #b5b5b5', margin: '5px 0' }} />
                                    {
                                        selectedTableShow && Object.keys(selectedTableShow)?.length > 0 ?
                                            <div style={{ width: '100%', display: 'flex', flexWrap: 'wrap', overflowY: 'auto', height: '300px', scrollbarWidth: 'thin' }}>
                                                {
                                                    Object.entries(selectedTableShow)?.map(([key, value], id) => {
                                                        return value && value?.length > 0 ? value?.map((v, ids) => {
                                                            let isActive = selectedColumns[key]?.includes(v?.column) ? true : false;
                                                            return (
                                                                <div style={{ width: '25%' }}>
                                                                    <div style={{
                                                                        display: 'flex', justifyContent: 'space-between',
                                                                        cursor: 'pointer', margin: '10px', borderRadius: '12px', display: "flex", justifyContent: 'space-between',
                                                                        // border: "1px solid #e2e8f0",
                                                                        border: isActive ? "1px solid #9333ea" : "1px solid #e2e8f0",
                                                                        // background: isActive ? "#000" : "#fff",
                                                                        // color: isActive ? "#fff" : "#000",
                                                                        padding: '10px'
                                                                    }} key={ids}
                                                                        onClick={() =>
                                                                            handleCheckboxChange(key, v?.column)
                                                                        }

                                                                    >
                                                                        <div>
                                                                            <h4 style={{ fontSize: '13px' }}>{v?.label?.replace(/_/g, " ")}</h4>
                                                                            <h6 style={{ fontSize: '10px' }}>{key?.replace(/_/g, " ")?.toUpperCase()}</h6>
                                                                        </div>
                                                                        <FormControlLabel
                                                                            sx={{
                                                                                "span": {
                                                                                    fontSize: '14px'
                                                                                },
                                                                                '& .MuiSvgIcon-root': { fontSize: 20 },

                                                                            }}

                                                                            control={
                                                                                <Checkbox
                                                                                    checked={isActive ? true : false}
                                                                                    sx={{

                                                                                        '&.Mui-checked': {
                                                                                            color: "#9333ea",
                                                                                        },
                                                                                    }}

                                                                                />
                                                                            }

                                                                        />
                                                                    </div>
                                                                </div>
                                                            )
                                                        })
                                                            : ""
                                                    })
                                                }
                                            </div>
                                            : ''}
                                </AccordionDetails>
                            </Accordion>
                            <div>

                            </div>
                        </div>



                    </>
                )}

                {reportType === "predefined" && (
                    <>
                        <div style={{ borderRadius: '12px', margin: '40px 0', boxShadow: "0px 2px 1px -1px rgba(0,0,0,0.2),0px 1px 1px 0px rgba(0,0,0,0.14),0px 1px 3px 0px rgba(0,0,0,0.12)", background: '#fff', display: 'flex', flexWrap: 'wrap' }}>
                            {predefined?.length > 0 ? predefined?.map(r => (

                                <div style={{ width: window.innerWidth > 1200 ? '20%' : window.innerWidth > 767 && window.innerWidth < 1200 ? "calc(100%/3)" : window.innerWidth < 767 ? "50%" : "100%" }}>
                                    <div style={{
                                        display: 'flex', justifyContent: 'space-between',
                                        cursor: 'pointer', margin: '10px', borderRadius: '12px', display: "flex", justifyContent: 'space-between',
                                        border: r.report_id == selectedReport ? "1px solid #9333ea" : "1px solid #e2e8f0",
                                        padding: '5px 10px', height: '70px'
                                    }}
                                        // key={ids}
                                        onClick={() => {
                                            setSelectedReport(r.report_id);
                                            getPredefinedReportcolumnforcustomReportByReportIdFn(r.report_id)
                                            // setDateParams({
                                            //     mongo_start_date: "",
                                            //     mongo_end_date: ""
                                            // })
                                            setSelectednbfc("")
                                        }
                                        }
                                    >
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <div style={{ width: "20px", height: '20px', borderRadius: '50%', border: r.report_id == selectedReport ? "2px solid #9333ea" : '2px solid grey', flexShrink: '0', padding: '3px 0' }}>
                                                {r.report_id == selectedReport ?
                                                    <div style={{ width: "10px", height: '10px', borderRadius: '50%', background: "#9333ea", margin: 'auto' }}></div>
                                                    : ""}
                                            </div>
                                            <h4 style={{ fontSize: '13px', marign: '0' }}>{r.report_name?.includes("_") ? r.report_name?.replace(/_/g, " ") : r.report_name}</h4>
                                        </div>

                                    </div>
                                </div>
                            )) : ''}
                        </div>
                    </>
                )}


                {showPreview && (
                    <div className="report-preview" style={{ marginTop: '30px' }} ref={tableRef}>
                        <div className="preview-header">
                            <div className="header-content">
                                <div className="left">
                                    <div className="icon-box">
                                        <svg viewBox="0 0 24 24">
                                            <path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z" />
                                        </svg>
                                    </div>
                                    <div className="heading">
                                        <h3>Report Preview</h3>
                                        <p>Generated on {new Date().toLocaleDateString()}</p>
                                    </div>
                                </div>
                                <div className="right">
                                    <span className="record-count">{PreviewTableData?.length || 0} records</span>
                                    <div className="live-status">
                                        <div className="dot"></div>
                                        <span className="label">Live Data</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="table-wrapper">
                            <table>
                                <thead>
                                    <tr>
                                        {Object.keys(PreviewTableData?.[0] || {})?.map(key => (
                                            <th key={key}>{key}</th>
                                        ))}
                                    </tr>
                                </thead>
                                <tbody>
                                    {previewPaginatedData?.length > 0 && previewPaginatedData?.map((row, rowIndex) => (
                                        <tr key={rowIndex}>
                                            {Object.keys(row)?.map((key, cellIndex) => (
                                                <td key={cellIndex}>
                                                    {row[key]}
                                                </td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <div className="pagination">
                                <button
                                    onClick={() => handlePageChange(currentPage - 1)}
                                    disabled={currentPage === 1}
                                >
                                    ← Prev
                                </button>

                                <button
                                    className={"active"}
                                >
                                    {currentPage}
                                </button>
                                <button
                                    onClick={() => handlePageChange(currentPage + 1)}
                                    disabled={currentPage === Math.ceil(totalItems / itemsPerPage)}
                                >
                                    Next →
                                </button>
                            </div>
                        </div>
                    </div>
                )}
            </div>

            {
                isOpenSidebar ?
                    <FilterSidebar
                        isOpenSidebar={isOpenSidebar}
                        setIsOpenSidebar={setIsOpenSidebar}
                        filters={filters}
                        setFilters={setFilters}
                        addFilter={addFilter}
                        removeFilter={removeFilter}
                        metadata={metadata}
                        setLoader={setLoader}
                        reportType={reportType}

                        dropdown2Ref={dropdown2Ref}
                    // showColumnDropdownFilter={showColumnDropdownFilter}
                    // setShowColumnDropdownFilter={setShowColumnDropdownFilter}
                    />
                    : ''
            }


        </div >
    );
};

export default CustomReportGenerator;




const FilterSidebar = ({ isOpenSidebar, setIsOpenSidebar, filters, setFilters, addFilter, removeFilter, metadata, setLoader, reportType, dropdown2Ref,
    // showColumnDropdownFilter, setShowColumnDropdownFilter

}) => {
    const [distinctValue, setDistinctValue] = useState([])
    const [searchTermFilter, setSearchTermFilter] = useState("")
    const [openDropdownIndex, setOpenDropdownIndex] = useState(null)

    const handleFilterChange = (index, field, value) => {
        const newFilters = [...filters];
        newFilters[index][field] = value;
        setFilters(newFilters);
    };

    useEffect(() => {
        function handleClickOutside(event) {
            if (dropdown2Ref.current && !dropdown2Ref.current.contains(event.target)) {
                setOpenDropdownIndex(null);
                setSearchTermFilter("")
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);


    const handleFetchDistinctValue = (data) => {
        const [table, column] = data?.split('.');
        setLoader(true)
        getDistinctValuesForTablByTablecolumn(table, column, callback => {
            setDistinctValue(callback)
            setLoader(false)
        })
    }

    const filteredMetadataNew = useMemo(() => {
        let arr = []

        if (metadata && metadata.length > 0) {

            arr = metadata.filter(col => {
                const searchValue = `${col?.label} (${col.table}.${col.column})`.toLowerCase();
                return searchValue.includes(searchTermFilter.toLowerCase());
            })
        }
        return arr;
    }, [searchTermFilter]);



    const getInputType = (columnValue) => {
        const dataType = getColumnDataType(columnValue);
        if (!dataType) return 'text';

        // Check for various date/time related data types
        const lowerDataType = dataType.toLowerCase();
        if (lowerDataType.includes('timestamp') ||
            lowerDataType.includes('datetime') ||
            lowerDataType === 'date') {
            return 'datetime-local'; // Use datetime-local for timestamp types
        }

        // You can add more type mappings here
        if (lowerDataType.includes('time') && !lowerDataType.includes('timestamp')) {
            return 'time';
        }

        if (lowerDataType.includes('number') ||
            lowerDataType.includes('integer') ||
            lowerDataType.includes('decimal') ||
            lowerDataType.includes('numeric')) {
            return 'number';
        }

        return 'text';
    };

    const getColumnDataType = (columnValue) => {
        if (!columnValue || !metadata?.length) return null;

        const column = metadata.find(col => {
            const value = reportType === "dynamic"
                ? `${col.table}.${col.column}`
                : `${col.table_from}.${col.column_name}`;
            return value === columnValue;
        });

        return column?.data_type || null;
    };

    return (
        <>
            <div className={`filter-sidebar ${isOpenSidebar ? "open" : ""}`}>
                {/* Header */}
                <div className="filter-header">
                    <div className="header-left">
                        <div className="filter-icon">
                            <svg fill="currentColor" viewBox="0 0 24 24">
                                <path d="M10 18h4v-2h-4v2zM3 6v2h18V6H3zm3 7h12v-2H6v2z" />
                            </svg>
                        </div>
                        <span>Smart Filters</span>
                    </div>
                    <button onClick={() => setIsOpenSidebar(false)} className="remove-btn" style={{ padding: '3px 5px 0 5px' }}>
                        <CloseIcon />
                    </button>
                </div>

                {/* Content */}
                <div className="sidebar-content">
                    <div className="space-y-4">
                        {filters.length === 0 ? (
                            // Empty State
                            <div className="empty-state">
                                <div className="empty-icon">
                                    <svg fill="currentColor" viewBox="0 0 24 24">
                                        <path d="M10 18h4v-2h-4v2zM3 6v2h18V6H3zm3 7h12v-2H6v2z" />
                                    </svg>
                                </div>
                                <p className="empty-title">No filters applied</p>
                                <button onClick={addFilter} className="add-filter-btn">
                                    <svg className="icon" fill="currentColor" viewBox="0 0 24 24">
                                        <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" />
                                    </svg>
                                    <span>Add Filter</span>
                                </button>
                            </div>
                        ) : (

                            <>

                                {filters && filters?.length > 0 && filters?.map((filter, index) => (
                                    <div key={index} className="filter-card">
                                        <div className="filter-header">
                                            <span>Filter {index + 1}</span>
                                            <button onClick={() => removeFilter(index)} className="remove-btn" style={{ padding: '3px 5px 0 5px' }}>
                                                <CloseIcon />
                                            </button>
                                        </div>

                                        <div className="filter-fields">


                                            <div className="builder-Tabs" style={{ marginTop: '0' }}>
                                                <div className="tabs-main" style={{ padding: '0' }}>

                                                    <div
                                                        className='main-select-filter' ref={dropdown2Ref}>


                                                        <div className='select-main-div'>
                                                            <button
                                                                className='main-button'
                                                                onClick={() => setOpenDropdownIndex(openDropdownIndex === index ? null : index)}>
                                                                <span>
                                                                    {filter?.column || "Select Column"}
                                                                </span>
                                                                <svg
                                                                    style={{
                                                                        width: '1rem',
                                                                        height: '1rem',
                                                                        transition: 'transform 0.2s ease',
                                                                        transform: openDropdownIndex === index ? 'rotate(180deg)' : 'rotate(0deg)',
                                                                    }}
                                                                    fill="currentColor"
                                                                    viewBox="0 0 24 24"
                                                                >
                                                                    <path d="M7 10l5 5 5-5z" />
                                                                </svg>
                                                            </button>

                                                            {openDropdownIndex === index && (
                                                                <div
                                                                    className='custom-btn-dropdown'
                                                                >
                                                                    <div className='dropdown-search'>
                                                                        <div style={{ position: 'relative' }}>
                                                                            <svg
                                                                                className='search-svg'
                                                                                fill="currentColor"
                                                                                viewBox="0 0 24 24"
                                                                            >
                                                                                <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z" />
                                                                            </svg>
                                                                            <input
                                                                                className='search-bar-input'
                                                                                type="text"
                                                                                placeholder="Search columns..."
                                                                                value={searchTermFilter}
                                                                                onChange={(e) => setSearchTermFilter(e.target.value)}

                                                                            />
                                                                        </div>
                                                                    </div>

                                                                    <div className='list-box'>
                                                                        {filteredMetadataNew?.map((col) => {
                                                                            const value = reportType == "dynamic" ? `${col.table}.${col.column}` : reportType == "predefined" ? `${col.table_from}.${col.column_name}` : "";
                                                                            const label = reportType == "dynamic" ? `${col.table}.${col.column}` : reportType == "predefined" ? `${col.display_label}` : "";
                                                                            return (
                                                                                <label
                                                                                    key={value}
                                                                                    className={`custom-list-label ${filter.column === value ? "active" : ""}`}
                                                                                    onClick={() => { handleFilterChange(index, 'column', value); handleFetchDistinctValue(value); setOpenDropdownIndex(null); }}
                                                                                >

                                                                                    <div style={{ flex: 1 }}>
                                                                                        <div style={{ fontSize: '12px', fontWeight: 500, color: '#334155' }}>{reportType == "dynamic" ? col.label : reportType == "predefined" ? col.display_label : ""}</div>
                                                                                        <div style={{ fontSize: '9px', color: '#64748b' }}>
                                                                                            {label}
                                                                                        </div>
                                                                                    </div>
                                                                                </label>
                                                                            );
                                                                        })}
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>




                                            {/* <select
                                                className="form-select"
                                                value={filter.column}
                                                onChange={(e) => { handleFilterChange(index, 'column', e.target.value); handleFetchDistinctValue(e.target.value) }}
                                            >
                                                <option value="">Select Column</option>
                                                {metadata?.length > 0 ? metadata?.map(col => (
                                                    <option

                                                        key={`${reportType == "dynamic" ? `${col.table}.${col.column}` : reportType == "predefined" ? `${col.table_from}.${col.column_name}` : ""}`}
                                                        value={`${reportType == "dynamic" ? `${col.table}.${col.column}` : reportType == "predefined" ? `${col.table_from}.${col.column_name}` : ""}`}
                                                    >
                                                        {`${reportType == "dynamic" ? `${col.label} (${col.table}.${col.column})` : reportType == "predefined" ? `${col?.display_label}` : ""}`}
                                                    </option>
                                                )) : ''}
                                            </select> */}

                                            {/* Operator Selection */}
                                            <select
                                                className="form-select"
                                                value={filter.operator}
                                                onChange={(e) => handleFilterChange(index, 'operator', e.target.value)}
                                            >
                                                <option value="=">=</option>
                                                <option value="!=">!=</option>
                                                <option value=">">{`>`}</option>
                                                <option value="<">{`<`}</option>
                                                <option value=">=">{`>=`}</option>
                                                <option value="<=">{`<=`}</option>
                                                <option value="LIKE">Contains</option>
                                            </select>

                                            {/* Value Input */}
                                            <div style={{ display: 'flex', gap: '10px' }}>
                                                <select
                                                    className="form-select"
                                                    value={filter.value}
                                                    onChange={(e) => handleFilterChange(index, 'value', e.target.value)}
                                                >
                                                    <option>Select Value</option>
                                                    {
                                                        distinctValue && distinctValue?.length > 0 ?
                                                            distinctValue?.map((value) => {
                                                                return (
                                                                    <option value={value}>{value}</option>
                                                                )
                                                            })
                                                            : ''}
                                                </select>
                                                <input
                                                    // type="text"
                                                    type={getInputType(filter.column)}
                                                    className="form-input"
                                                    placeholder="Enter value"
                                                    value={filter.value}
                                                    onChange={(e) => handleFilterChange(index, 'value', e.target.value)}
                                                />
                                            </div>

                                            {/* Logic Operator (only show if not the last filter) */}
                                            {index < filters.length - 1 && (
                                                <select
                                                    className="form-select"
                                                    value={filter.logic}
                                                    onChange={(e) => handleFilterChange(index, 'logic', e.target.value)}
                                                >
                                                    <option value="AND">AND</option>
                                                    <option value="OR">OR</option>
                                                </select>
                                            )}
                                        </div>
                                    </div>
                                ))}


                                <button onClick={addFilter} className="add-filter-btn">
                                    <svg className="icon" fill="currentColor" viewBox="0 0 24 24">
                                        <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" />
                                    </svg>
                                    <span>Add Filter</span>
                                </button>
                            </>
                        )}
                    </div>
                </div>
            </div>
        </>
    )
}
